import { create } from "zustand";

export const useRedebanStore = create((set) => ({
  inProgress: false,
  explanations: [
    {
      id: 1,
      content: "Un momento, nos estamos conectando con el datáfono...",
      end: false,
      image: 'none',
    },
    {
      id: 2,
      content: `
        🟢 Pulsa el botón verde en el datáfono para continuar.<br/>
        Si deseas cancelar pulsa el botón rojo 🔴, hazlo después de pulsar el botón verde.<br/>
        <i>Si cancelas, espera un momento mientras procesamos la respuesta.</i>
      `,
      end: false,
      image: 'pay',
    },
    {
      id: 3,
      content:
        "Por favor, espera un momento mientras verificamos la transacción.",
      end: false,
      image: 'pay',
    },
    {
      id: 4,
      content: "💳 Procesando el pago... ¡Gracias por tu paciencia!",
      end: false,
      image: 'pay',
    },
    {
      id: 5,
      content: `
        🎉 ¡Tu compra se realizó con éxito!
      `,
      end: false,
      image: 'success',
    },
    {
      id: 6,
      content: `
        ⚠️ Algo salió mal al procesar tu compra. </br>
        Te invitamos a intentarlo de nuevo.</br></br>
        ℹ️ Si el pago fue exitoso pero no se completó la compra, por favor contacta al administrador.
      `,
      end: true,
      image: 'error',
    },
    {
      id: 7,
      content: `
        🖨️ Por favor, espera un momento... estamos imprimiendo tu recibo.
      `,
      end: false,
      image: 'print',
    },
    {
      id: 8,
      content: `
        ¡Gracias! Tu compra ha sido procesada correctamente, recuerda retirar tu recibo.
      `,
      end: true,
      image: 'success',
    },
    {
      id: 9,
      content: `
        Has cancelado la compra.<br />
        <strong>¡Esperamos verte pronto de nuevo!</strong>
      `,
      end: true,
      image: 'error',
    },
    {
      id: 10,
      content: `
        Ha finalizado el tiempo para procesar la compra.<br />
        <strong>¡Vuelve a intentarlo!</strong>
      `,
      end: true,
      image: 'error',
    },
  ],
  startTimer: false,
  currentExplanation: null,
  currentTransaction: null,
  setInProgress: (inProgress) => set({ inProgress }),
  setCurrentExplanation: (currentExplanation) => set({ currentExplanation }),
  setCurrentTransaction: (currentTransaction) => set({ currentTransaction }),
  setStartTimer: (startTimer) => set({ startTimer }),
}));
